module.exports = __webpack_public_path__ + "36d50c1381fda7c71d12b6643cbe1ee0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 421
// module chunks = 0